import { A11yModule } from '@angular/cdk/a11y';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { OneHubSandboxModule } from '@lms-approval/onehub-sandbox';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from '../environments/environment';

import { APP_ROUTING } from './app.routing';
import { AppComponent } from './app.component';
import { TokenService } from './services/token.service';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './utils/msal-configuration.utils';
import { TokenDataStorageService } from './services/token-data-storage.service';
import { EnvironmentService, ServiceboxAppConfigModule } from '@adnoc/servicebox';
import { SandboxEnvironmentService } from './services/sandbox-environment.service';
import { MicroFrontendService } from './services/micro-frontend.service';
import { IsRemoteEntryLoadedGuard } from './guards/is-remote-entry-loaded-guard.service';
import { ParcelModule } from 'single-spa-angular/parcel';
import { RemoteLoaderComponent } from './components/remote-loader/remote-loader.component';
import { ConfigService } from './services/config.service';
import { SANDBOX_CONFIG } from './tokens/config.token';
import { UserMappingComponent } from './components/user-mapping/user-mapping.component';
import { UserMappingService } from './services/user-mapping.service';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { OnehubFormUiModule } from '@adnoc/onehub-form-ui';

@NgModule({
  declarations: [
    AppComponent,
    RemoteLoaderComponent,
    UserMappingComponent
  ],
  imports: [
    A11yModule,
    BrowserAnimationsModule,
    BrowserModule,
    ReactiveFormsModule,
    MsalModule,
    ParcelModule,
    RouterModule.forRoot(APP_ROUTING),
    ToastrModule.forRoot({
      timeOut: 3000,
      closeButton: false,
      tapToDismiss: true,
      positionClass: 'external-toast-container'
    }),
    ServiceboxAppConfigModule.forRoot({
      production: environment.production,
      appUiUrl: environment.uiUrl,
      oneHubApiUrl: environment.apiUrl
    }),
    OneHubSandboxModule,
    MatCard,
    MatCardTitle,
    MatCardContent,
    OnehubFormUiModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: EnvironmentService,
      useClass: SandboxEnvironmentService,
    },
    {
      provide: SANDBOX_CONFIG,
      useValue: {
        apiUrl: environment.apiUrl,
        moduleName: environment.moduleName,
        production: environment.production,
        remoteEntryUrl: environment.remoteEntryUrl,
        uniqueName: environment.uniqueName,
      },
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    TokenDataStorageService,
    MicroFrontendService,
    IsRemoteEntryLoadedGuard,
    ConfigService,
    TokenService,
    UserMappingService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
